import service from "@/api/service";
import { GetResponse } from "@/api/coupon-preview/response";
import { GetRequest } from "@/api/coupon-preview/request";

/**
 * クーポンプレビュー取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/coupon-preview", getRequest);
  return response.data as GetResponse;
}
